<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3">
              <LeftMenu active="bank" />
            </div>
            <div class="col-md-9">
              <Alert
                v-if="deleteSuccess"
                :alert="{
                  title: 'Berhasil menghapus data',
                  type: 'success',
                  content: `Data bank '${deleteItem.name}' telah berhasil dihapus dari sistem`,
                }"
              />
              <Alert
                v-if="deleteFailed"
                :alert="{
                  title: 'Gagal menghapus data',
                  type: 'danger',
                  content: `Terjadi kesalahan pada sistem. Data bank '${deleteItem.name}' gagal dihapus dari sistem`,
                }"
              />
              <PageContentHeader
                :data="data"
                :fromUrl="fromUrl || ''"
                :fromTab="$route.query.fromTab || ''"
              />
              <!--div>
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <b-tabs pills>
                        <b-tab v-for="item in tabs"
                          v-bind:key="item.title + String(Math.random(1023))" :title="item.title" @click="()=>filterTab(item.filter)"/>
                      </b-tabs>
                    </div>
                  </div>
                </!--div>-->

              <div class="card card-filter-sort no-print">
                <div class="row">
                  <div class="col-md-9">
                    <FormRow
                      :row="filters"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                  <div class="col-md-3">
                    <FormRow
                      :row="sort"
                      @handleChange="(e) => handleChange(e)"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="row">
                  <div class="col-md-4">
                    <div class="row form-group mt-3">
                      <div class="col-md-12 d-flex flex-between">
                        <label class="mb-0 mr-3">Tampilkan</label>
                        <select class="form-control" v-model="perPage">
                          <option value="10">10 data</option>
                          <option v-if="rows.length > 10" value="25">
                            25 data
                          </option>
                          <option v-if="rows.length > 25" value="50">
                            50 data
                          </option>
                          <option v-if="rows.length > 50" value="100">
                            100 data
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 offset-md-2">
                    <div class="form-group mt-3">
                      <input
                        type="text"
                        class="form-control with-icon-left without-label"
                        v-model="filter"
                        placeholder="Cari data di sini"
                        ref="focusMe"
                        @keydown="$event.stopImmediatePropagation()"
                      />
                      <i class="material-symbols-outlined">search</i>
                    </div>
                  </div>
                </div>
                <datatable
                  v-if="loaded && rows.length"
                  :columns="columns"
                  :per-page="parseInt(perPage)"
                  :data="rows"
                  :filter="filter"
                  class="table table-hover responsive"
                ></datatable>
                <EmptyState
                  v-else-if="loaded && !rows.length"
                  :data="{ size: 'small' }"
                />
                <Loading v-else />
                <br />
                <p v-if="rows.length">
                  Menampilkan
                  {{ rows.length > parseInt(perPage) ? perPage : rows.length }}
                  data dari total {{ rows.length }} data
                </p>
                <datatable-pager
                  v-if="loaded && rows.length"
                  v-model="page"
                  class="nav nav-tabs datatable-pager"
                  type="abbreviated"
                ></datatable-pager>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      v-for="row in rows"
      v-bind:key="row.id + String(Math.random(1023))"
      :id="'delete' + row.id"
      @click="
        () => {
          deleteData(row.id, row.nama);
        }
      "
      style="display: none"
    ></button>
    <div class="modal modal-confirm" id="modalDelete" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <!--  <h5 class="modal-title">Modal title</h5>  -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <h3 class="confirm-title">Delete Confirmation</h3> -->
            <img
              class="img-illustration delete-alert mb-0"
              src="/img/alert-triangle.svg"
              style="width: 40%"
            />
            <p class="confirm-content mb-2">
              Apakah Anda yakin untuk menghapus data berikut?
            </p>
            <h4>{{ deleteItem.name }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-danger"
              data-dismiss="modal"
            >
              TIDAK
            </button>
            <button
              id="btnDeleteItem"
              class="btn btn-danger"
              @click="
                () => {
                  confirmDelete(deleteItem.id);
                }
              "
              data-dismiss="modal"
            >
              YA
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Alert from "@/components/Alert.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import LeftMenu from "@/components/LeftMenu.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import { HTTP } from "@/config.js";
import { dataBank, tabs, sort, filters } from "@/data/Master.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';

export default {
  name: "Bank",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    LeftMenu,
    Alert,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      deleteItem: {
        id: "",
        name: "",
      },
      deleteSuccess: false,
      deleteFailed: false,
      loaded: false,
      data: dataBank,
      filters: filters,
      sort: sort,
      tabs: tabs,
      created_at: "",
      orderBy: "desc",
      id_bank: "",
      pembayaran: ["Umum", "BPJS", "Bank Lain"],
      columns: [
        {
          label: "Kode",
          field: "kode",
          headerClass: "class-in-header second-class",
        },
        { label: "Bank", field: "nama" },
        {
          label: "",
          class: "dropdown",
          representedAs: (
            row
          ) => `<a class="btn btn-sm btn-success btn-icon" href="/#/master/bank/edit/${row.id}"><i class="material-symbols-outlined">create</i></a>
                <a class="btn btn-sm btn-icon btn-basic" data-toggle="dropdown" data-target="#" id="actionDropdown" aria-expanded="true">
                    <i class="material-symbols-outlined">apps
                  </i>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-account" aria-labelledby="actionDropdown">
                    <a class="dropdown-item" href="/#/master/bank/edit/${row.id}" >
                        <i class="material-symbols-outlined">create</i>
                        Edit Data Bank
                    </a>
                    <a class="dropdown-item" data-toggle="modal" data-target="#modalDelete" onclick="document.getElementById('delete${row.id}').click()">
                        <i class="material-symbols-outlined">delete</i>
                        Hapus Data Bank
                    </a>
                </div>
                <div>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    deleteData(id, name) {
      this.deleteItem = {
        id: id,
        name: name,
      };
    },
    async confirmDelete(id) {
      //console.log(id);
      let result = await this.$store.state.HTTP.delete("bank/" + id);
      //console.log(result);
      if (result.status == 200) {
        this.deleteSuccess = true;
        await this.displayList();
        this.$nextTick(() => {
          if (this.$refs.focusMe) {
            this.$refs.focusMe.focus();
          }
        });
      } else {
        this.deleteFailed = true;
      }
      this.resetAlert();
    },
    resetAlert() {
      let self = this;
      setTimeout(function() {
        self.deleteSuccess = false;
        self.deleteFailed = false;
      }, 5000);
    },
    async filterTab(filter) {
      //console.log(filter);
      this["id_bank"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      //console.log(`${e.target.name}:${this[e.target.name]}`);
      await this.displayList();
      //this.$nextTick(()=>{if(this.$refs.focusMe){ this.$refs.focusMe.focus()}});
    },
    displayList: async function() {
      this.loaded = false;
      this.errors = [];
      let params = `?per_page=999999999999&orderBy=${this.orderBy}`;
      if (this["created_at"]) {
        params += `&created_at=${this.created_at}`;
      }
      if (this["id_bank"]) {
        params += `&id_bank=${this.id_bank}`;
      }
      try {
        let result = await this.$store.state.HTTP.get("bank" + params);
        //console.log(result);
        if (result.status == "200") {
          //console.log("berhasil");
          this.rows = result.data.data;
          this.loaded = true;
          //console.log(this.rows);
        } else {
          //console.log(result.status);
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
    //let $=jQuery;
    //bootstrap.load_file($);
  },
};
</script>
